module.exports = __webpack_public_path__ + "static/media/la-business-journal.8aa2e4bb.jpg";